/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CliniShift Manager
 * The CliniShift Manager API is used to manage the CliniShift platform. This API is used by the CliniShift Manager Portal.
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ActivityChangeBase = zod.object({
  "type": zod.union([zod.enum(['datetime', 'reference', 'reference_set']),zod.string()]),
  "field": zod.string(),
  "label": zod.string()
});

export type ActivityChangeBase = zod.input<typeof ActivityChangeBase>;
export type ActivityChangeBaseOutput = zod.output<typeof ActivityChangeBase>;
